$(function() {
    $('#see-all-events').on('click', function() {
        $('#events').find('.event').show();
        $(this).hide();
    });
});